import React from 'react';

const SharedDemos: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Shared Demos</h1>
      <p className="text-gray-600">Shared demos component - to be implemented</p>
    </div>
  );
};

export default SharedDemos;
